<template>
  <div>
    <b-row class='mt-2'>
      <b-col>
        <h4 v-if='item && item.type'>{{item.type.toUpperCase()}}</h4>
      </b-col>
    </b-row>
    <b-row class='mb-2'>
      <b-col v-for='(locale, i) in locales' :key='i'>
        <label :for="`flatpage${flatPage.id}_item${item.id}_locale${i}`">Tekst {{locale}}</label>
        <b-form-textarea :id="`flatpage${flatPage.id}_item${item.id}_locale${i}`"
          rows='3'
          max-rows='6'
          placeholder='wpisz tekst...'
          :value='item.value[locale]'
          @input='(e) => actions.handleItemTextValueChanged(flatPage.id, item.id, e, locale)'
        />
      </b-col>
    </b-row>
    <b-row class='mb-2'>
      <b-col>
        <label>Kolor czcionki</label>
        <b-form-input
          type='color'
          :value='color'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "color", e)'
        />
      </b-col>
      <b-col>
        <label>Wielkość czcionki</label>
        <b-form-input
          type='number'
          :value='size'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "size", e)'
        />
      </b-col>
      <b-col>
        <label>Czcionka</label>
        <b-form-checkbox
          v-model='modelFontWeight'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "fontWeight", e)'
          value="bold"
          unchecked-value="normal"
        >
          <div style='font-weight: bold'>bold</div>
        </b-form-checkbox>
        <b-form-checkbox
          v-model='modelFontStyle'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "fontStyle", e)'
          value="italic"
          unchecked-value="normal"
        >
          <div style='font-style: italic'>italic</div>
        </b-form-checkbox>
      </b-col>
      <b-col>
        <label>Margines górny</label>
        <b-form-input
          type='number'
          :value='marginTop'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "marginTop", e)'
        />
      </b-col> 
      <b-col>
        <label>Margines dolny</label>
        <b-form-input
          type='number'
          :value='marginBottom'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "marginBottom", e)'
        />
      </b-col>      
    </b-row>
  </div>
</template>

<script>

  import { LOCALES } from '@/utils';
  import {
    handleItemTextValueChanged,
    handleItemTextStyleChanged,
  } from '@/store/utils.js'
  
  export default {
    props: ['flatPage', 'item'],
    computed: {
      color() {
        try {
          return this.item.style.color
        } catch (e) {
          return '#000000'
        }
      },
      size() {
        try {
          return this.item.style.size || 12
        } catch (e) {
          return 12
        }
      },
      marginTop() {
        try {
          return this.item.style.marginTop || 10
        } catch (e) {
          return 10
        }
      },
      marginBottom() {
        try {
          return this.item.style.marginBottom || 10
        } catch (e) {
          return 10
        }
      },
    },
    data() {
      return {
        actions: {
          handleItemTextValueChanged,
          handleItemTextStyleChanged,
        },
        locales: LOCALES,
        modelFontWeight: this.item.style && this.item.style.fontWeight ? this.item.style.fontWeight : 'normal',
        modelFontStyle: this.item.style && this.item.style.fontStyle ? this.item.style.fontStyle : 'normal',
      }
    },
  }
</script>
